/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// module to make the lodash library/api injectable.
angular.module('lodash', [])
  .factory('_', ['$window', lodashFactory]);

// eslint-disable-next-line @typescript-eslint/naming-convention
function lodashFactory($window) {
  return $window._;
}
